// // // app/components/utils/templateUtils.js

// // export function buildUniversalHeader(form, fallbackDate) {
// //   const defaults = {
// //     header_line1: "Esteemed Residency Program",
// //     header_line2: "Well-Known University",
// //     header_addr1: "1234 University Way",
// //     header_addr2: "Big City, Florida 54321",
// //   };
// //   const line1 = (form.header_line1 || defaults.header_line1).trim();
// //   const line2 = (form.header_line2 || defaults.header_line2).trim();
// //   const addr1 = (form.header_addr1 || defaults.header_addr1).trim();
// //   const addr2 = (form.header_addr2 || defaults.header_addr2).trim();
// //   const dateLine = (form.date || fallbackDate || "").trim();

// //   return [line1, line2, addr1, addr2, dateLine].filter(Boolean).join("\n");
// // }

// // export function buildRecipientBlock(form) {
// //   const lines = [
// //     form.recipient_name,
// //     form.recipient_title,
// //     form.recipient_org,
// //     form.recipient_addr1,
// //     form.recipient_addr2,
// //   ]
// //     .map((s) => (s || "").trim())
// //     .filter(Boolean);
// //   return lines.length ? lines.join("\n") : "";
// // }

// // export function applyTemplateShell(letterText, template, form, fallbackDate) {
// //   const blocks = String(letterText || "").replace(/\r\n/g, "\n").split(/\n{2,}/g);

// //   const universalHeader = buildUniversalHeader(form, fallbackDate);
// //   const recipientBlock = template.id === "professional" ? buildRecipientBlock(form) : "";
// //   const fullHeader = [universalHeader, recipientBlock].filter(Boolean).join("\n\n");

// //   // Subject line (avoid duplicate "for for")
// //   const rawPrefix = (template.subjectPrefix || "Letter of Recommendation").replace(/\s+/g, " ").trim();
// //   const endsWithFor = /\bfor\b:?$/i.test(rawPrefix); 
// //   let subjectCore = rawPrefix;
// //   if (form.student) {
// //     subjectCore += endsWithFor ? ` ${form.student}` : ` for ${form.student}`;
// //   }
// //   const subjectLine = `Subject: ${subjectCore}`;

// //   const subjectIdx = blocks.findIndex((b) => /^Subject:\s/i.test(b.trim()));
// //   if (subjectIdx >= 0) blocks[subjectIdx] = subjectLine;
// //   else blocks.splice(1, 0, subjectLine);

// //   const desiredGreeting = template.greeting({ form });
// //   const greetIdx = blocks.findIndex((b) => /^((Dear\s.+,)|(To Whom It May Concern,))/i.test(b.trim().split("\n")[0]));
// //   const gIdx = greetIdx >= 0 ? greetIdx : Math.min(blocks.length, 2);
// //   const gLines = (blocks[gIdx] || "").split("\n");
// //   gLines[0] = desiredGreeting;
// //   blocks[gIdx] = gLines.join("\n");

// //   blocks[0] = fullHeader;

// //   return blocks.join("\n\n");
// // }

// // app/components/utils/templateUtils.js

// // Escape helper so we can safely place text in HTML when needed
// function escapeHtml(s = "") {
//   return String(s)
//     .replace(/&/g, "&amp;")
//     .replace(/</g, "&lt;")
//     .replace(/>/g, "&gt;")
//     .replace(/"/g, "&quot;")
//     .replace(/'/g, "&#39;");
// }

// // Read logo settings from the form with sensible defaults and guards
// function getLogoSettings(form = {}) {
//   const dataUrl =
//     form.logoDataUrl ||
//     form.header_logo_dataurl ||
//     form.logo ||
//     form.headerLogo ||
//     "";

//   const align = (form.logoAlign || form.header_logo_align || "left").toLowerCase();
//   const widthRaw = Number(form.logoWidth || form.header_logo_width || 140);
//   // clamp width: 60–300px
//   const width = Math.min(300, Math.max(60, isNaN(widthRaw) ? 140 : widthRaw));
//   const maxHeight = Number(form.logoMaxHeight || 120);

//   return { dataUrl, align, width, maxHeight };
// }

// // Build an HTML logo block that fits nicely (no stretching, respects width)
// function buildLogoHtml(form = {}) {
//   const { dataUrl, align, width, maxHeight } = getLogoSettings(form);
//   if (!dataUrl) return "";

//   const justify =
//     align === "center" ? "center" : align === "right" ? "flex-end" : "flex-start";

//   return `
// <div style="display:flex;justify-content:${justify};padding-bottom:8px;">
//   <img
//     src="${dataUrl}"
//     alt="School Logo"
//     style="width:100%;max-width:${width}px;height:auto;max-height:${maxHeight}px;object-fit:contain;"
//   />
// </div>`;
// }

// export function buildUniversalHeader(form, fallbackDate) {
//   const defaults = {
//     header_line1: "Esteemed Residency Program",
//     header_line2: "Well-Known University",
//     header_addr1: "1234 University Way",
//     header_addr2: "Big City, Florida 54321",
//   };
//   const line1 = (form.header_line1 || defaults.header_line1).trim();
//   const line2 = (form.header_line2 || defaults.header_line2).trim();
//   const addr1 = (form.header_addr1 || defaults.header_addr1).trim();
//   const addr2 = (form.header_addr2 || defaults.header_addr2).trim();
//   const dateLine = (form.date || fallbackDate || "").trim();

//   return [line1, line2, addr1, addr2, dateLine].filter(Boolean).join("\n");
// }

// export function buildRecipientBlock(form) {
//   const lines = [
//     form.recipient_name,
//     form.recipient_title,
//     form.recipient_org,
//     form.recipient_addr1,
//     form.recipient_addr2,
//   ]
//     .map((s) => (s || "").trim())
//     .filter(Boolean);
//   return lines.length ? lines.join("\n") : "";
// }

// export function applyTemplateShell(letterText, template, form, fallbackDate) {
//   const raw = String(letterText || "").replace(/\r\n/g, "\n");
//   const blocks = raw.split(/\n{2,}/g);

//   const universalHeader = buildUniversalHeader(form, fallbackDate);
//   const recipientBlock = template.id === "professional" ? buildRecipientBlock(form) : "";
//   const fullHeaderText = [universalHeader, recipientBlock].filter(Boolean).join("\n\n");

//   // Decide if this letter should be treated as HTML
//   const isHtmlTemplate =
//     template?.format === "html" ||
//     template?.html === true ||
//     /<\/?[a-z][\s\S]*>/i.test(raw);

//   // If HTML: prepend a flexible, well-sized logo (when provided) and
//   // render the text header in a white-space:pre-wrap container.
//   let headerForBlock0 = fullHeaderText;
//   if (isHtmlTemplate) {
//     const logoHtml = buildLogoHtml(form);
//     const headerHtml = `
// ${logoHtml}
// <div style="white-space:pre-wrap;line-height:1.45;color:#0F172A;">
//   ${escapeHtml(fullHeaderText)}
// </div>`.trim();
//     headerForBlock0 = headerHtml;
//   }

//   // Subject line (avoid duplicate "for for")
//   const rawPrefix = (template.subjectPrefix || "Letter of Recommendation")
//     .replace(/\s+/g, " ")
//     .trim();
//   const endsWithFor = /\bfor\b:?$/i.test(rawPrefix);
//   let subjectCore = rawPrefix;
//   if (form.student) {
//     subjectCore += endsWithFor ? ` ${form.student}` : ` for ${form.student}`;
//   }
//   const subjectLine = `Subject: ${subjectCore}`;

//   const subjectIdx = blocks.findIndex((b) => /^Subject:\s/i.test(b.trim()));
//   if (subjectIdx >= 0) blocks[subjectIdx] = subjectLine;
//   else blocks.splice(1, 0, subjectLine);

//   const desiredGreeting = template.greeting({ form });
//   const greetIdx = blocks.findIndex((b) =>
//     /^((Dear\s.+,)|(To Whom It May Concern,))/i.test(b.trim().split("\n")[0])
//   );
//   const gIdx = greetIdx >= 0 ? greetIdx : Math.min(blocks.length, 2);
//   const gLines = (blocks[gIdx] || "").split("\n");
//   gLines[0] = desiredGreeting;
//   blocks[gIdx] = gLines.join("\n");

//   // Replace header block with either the HTML block (if HTML) or the raw text
//   blocks[0] = headerForBlock0;

//   return blocks.join("\n\n");
// }


// app/components/utils/templateUtils.js
"use client";

/* ------------------------------ internal helpers ------------------------------ */
// Escape helper so we can safely place text in HTML when needed
function escapeHtml(s = "") {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// Read logo settings from the form with sensible defaults and guards
function getLogoSettings(form = {}) {
  // Support multiple possible keys (camel/snake/legacy) to be resilient
  const dataUrl =
    form.header_logoDataUrl || // <-- your current form field
    form.logoDataUrl ||
    form.header_logo_dataurl ||
    form.logo ||
    form.headerLogo ||
    "";

  const align =
    (form.header_logoAlign || // <-- your current form field
      form.logoAlign ||
      form.header_logo_align ||
      "left") + "";
  const alignNorm = align.toLowerCase();

  const widthRaw =
    Number(
      form.header_logoWidth || // <-- your current form field
        form.logoWidth ||
        form.header_logo_width ||
        140
    ) || 140;

  // clamp width: 60–300px
  const width = Math.min(300, Math.max(60, isNaN(widthRaw) ? 140 : widthRaw));
  const maxHeight = Number(form.logoMaxHeight || 120);

  return { dataUrl, align: alignNorm, width, maxHeight };
}

// Build an HTML logo block that fits nicely (no stretching, respects width)
function buildLogoHtml(form = {}) {
  const { dataUrl, align, width, maxHeight } = getLogoSettings(form);
  if (!dataUrl) return "";

  const justify =
    align === "center" ? "center" : align === "right" ? "flex-end" : "flex-start";

  return `
<div style="display:flex;justify-content:${justify};padding-bottom:8px;">
  <img
    src="${dataUrl}"
    alt="School Logo"
    style="width:100%;max-width:${width}px;height:auto;max-height:${maxHeight}px;object-fit:contain;"
  />
</div>`.trim();
}

/* ------------------------------ exported helpers ------------------------------ */
export function buildUniversalHeader(form = {}, fallbackDate = "") {
  const defaults = {
    header_line1: "Esteemed Residency Program",
    header_line2: "Well-Known University",
    header_line3: "", // optional third line
    header_addr1: "1234 University Way",
    header_addr2: "Big City, Florida 54321",
  };

  const line1 = (form.header_line1 ?? defaults.header_line1).toString().trim();
  const line2 = (form.header_line2 ?? defaults.header_line2).toString().trim();
  const line3 = (form.header_line3 ?? defaults.header_line3).toString().trim();
  const addr1 = (form.header_addr1 ?? defaults.header_addr1).toString().trim();
  const addr2 = (form.header_addr2 ?? defaults.header_addr2).toString().trim();
  const dateLine = (form.date || fallbackDate || "").toString().trim();

  return [line1, line2, line3, addr1, addr2, dateLine]
    .filter(Boolean)
    .join("\n");
}

export function buildRecipientBlock(form = {}) {
  const lines = [
    form.recipient_name,
    form.recipient_title,
    form.recipient_org,
    form.recipient_addr1,
    form.recipient_addr2,
  ]
    .map((s) => (s || "").trim())
    .filter(Boolean);

  return lines.length ? lines.join("\n") : "";
}

/**
 * Wrap the model-built letter in the chosen template:
 * - Prepend universal header (and recipient for professional template)
 * - Insert or replace a subject line
 * - Normalize greeting via template.greeting({ form })
 * - If HTML template: render header as HTML and include a scaled logo block
 */
export function applyTemplateShell(letterText, template = {}, form = {}, fallbackDate) {
  const raw = String(letterText || "").replace(/\r\n/g, "\n");
  const blocks = raw.split(/\n{2,}/g);

  const universalHeader = buildUniversalHeader(form, fallbackDate);
  const recipientBlock =
    template.id === "professional" ? buildRecipientBlock(form) : "";
  const fullHeaderText = [universalHeader, recipientBlock].filter(Boolean).join("\n\n");

  // Decide if this letter should be treated as HTML
  const isHtmlTemplate =
    template?.format === "html" ||
    template?.html === true ||
    /<\/?[a-z][\s\S]*>/i.test(raw);

  // If HTML: prepend a flexible, well-sized logo (when provided) and
  // render the text header in a white-space:pre-wrap container.
  let headerForBlock0 = fullHeaderText;
  if (isHtmlTemplate) {
    const logoHtml = buildLogoHtml(form);
    const headerHtml = `
${logoHtml}
<div style="white-space:pre-wrap;line-height:1.45;color:#0F172A;">
  ${escapeHtml(fullHeaderText)}
</div>`.trim();
    headerForBlock0 = headerHtml;
  }

  // Subject line (avoid duplicate "for for")
  const rawPrefix = (template.subjectPrefix || "Letter of Recommendation")
    .replace(/\s+/g, " ")
    .trim();
  const endsWithFor = /\bfor\b:?$/i.test(rawPrefix);
  let subjectCore = rawPrefix;
  if (form.student) {
    subjectCore += endsWithFor ? ` ${form.student}` : ` for ${form.student}`;
  }
  const subjectLine = `Subject: ${subjectCore}`;

  // Insert/replace subject line
  const subjectIdx = blocks.findIndex((b) => /^Subject:\s/i.test(b.trim()));
  if (subjectIdx >= 0) blocks[subjectIdx] = subjectLine;
  else blocks.splice(1, 0, subjectLine);

  // Normalize greeting via template
  const desiredGreeting =
    typeof template.greeting === "function"
      ? template.greeting({ form })
      : "Dear Admissions Committee,";

  const greetIdx = blocks.findIndex((b) =>
    /^((Dear\s.+,)|(To Whom It May Concern,))/i.test(b.trim().split("\n")[0])
  );
  const gIdx = greetIdx >= 0 ? greetIdx : Math.min(blocks.length, 2);
  const gLines = (blocks[gIdx] || "").split("\n");
  gLines[0] = desiredGreeting;
  blocks[gIdx] = gLines.join("\n");

  // Replace header block with either the HTML block (if HTML) or the raw text
  blocks[0] = headerForBlock0;

  return blocks.join("\n\n");
}
